import { useState } from 'react';

export const useFormData = (initialData = {}) => {
  const [formData, setFormData] = useState(initialData);

  const updateFormData = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFormData = () => {
    setFormData(initialData);
  };

  return {
    formData,
    setFormData,
    updateFormData,
    resetFormData
  };
};
